import { render, staticRenderFns } from "./Preorder.vue?vue&type=template&id=13bbacc5&scoped=true"
import script from "./Preorder.vue?vue&type=script&lang=js"
export * from "./Preorder.vue?vue&type=script&lang=js"
import style0 from "./Preorder.vue?vue&type=style&index=0&id=13bbacc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbacc5",
  null
  
)

export default component.exports